import { render, staticRenderFns } from "./LibraryTextGroup.vue?vue&type=template&id=6df915c3&"
import script from "./LibraryTextGroup.vue?vue&type=script&lang=js&"
export * from "./LibraryTextGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LibraryTextGroup.vue"
export default component.exports